import React from 'react';
import { useEmployeeService } from 'domain/shared/employee';
import { FormShowTemplate, DEFAULT_ERROR_MESSAGE } from 'framework/form';
import { useEmployeeId } from 'domain/people/employee/employeeIdentityRouting';
import { FormFieldsData } from 'validation-schema-library/build/validation/types';
import PersonalInfoContent from '../shared/PersonalInfoContent';
import getPersonalInfoValidationSchema from '../createupdate/personalInfoValidationSchema';
import { useShowContext } from 'framework/show';
import { useMessageService, ErrorMessage } from 'framework/ui/Message';

const EmployeePersonalInfoSummary: React.FC = () => {
  const { updatePersonalInfo, getForUpdate } = useEmployeeService();
  const employeeId = useEmployeeId();
  const { setData } = useShowContext();
  const { addMessage } = useMessageService('employeePersonalInfoSummary');

  const handleErrorsOnSubmit = () => {
    addMessage(new ErrorMessage(DEFAULT_ERROR_MESSAGE));
  };

  if (!employeeId) {
    return null;
  }

  const handleSubmit = async (values: FormFieldsData): Promise<void | object> => {
    const result = await updatePersonalInfo(employeeId, values);
    if (result && setData) {
      setData(result);
    }
    return result;
  };

  return (
    <FormShowTemplate
      getDataFunc={() => getForUpdate(employeeId)}
      submitFormFunc={handleSubmit}
      getValidationSchemaFunc={getPersonalInfoValidationSchema}
      messageContext="employeePersonalInfoSummary"
      handleErrorsOnSubmit={handleErrorsOnSubmit}
    >
      <PersonalInfoContent />
    </FormShowTemplate>
  );
};

export default EmployeePersonalInfoSummary;
